(() => {
  'use strict';

  /*
   * ============================================================
   * GOAL JAPAN チーム専用クーポン処理
   * ============================================================
   */

  const ACCESS_KEY = 'goal_team_access';
  const ACTIVE_CLASS = 'goal-team-discount-active';

  let observer = null;
  let updateScheduled = false;

  /**
   * TEAM GOALSTUDIO経由か確認します。
   */
  function isTeamDiscountActive() {
    /*
     * team-access.jsの公開機能が利用できる場合は、
     * そちらの判定を優先します。
     */
    try {
      if (
        window.GoalTeamAccess &&
        typeof window.GoalTeamAccess.isActive === 'function'
      ) {
        return window.GoalTeamAccess.isActive();
      }
    } catch (error) {
      console.warn(
        '[GOAL discount] GoalTeamAccessの確認に失敗しました。',
        error
      );
    }

    /*
     * 読み込み順の関係でGoalTeamAccessが
     * まだ作成されていない場合はこちらで判定します。
     */
    try {
      return sessionStorage.getItem(ACCESS_KEY) === '1';
    } catch (error) {
      return false;
    }
  }

  /**
   * クーポン入力欄と追加決済ボタンを更新します。
   */
  function updateDisplay() {
    const active = isTeamDiscountActive();

    document.documentElement.classList.toggle(
      ACTIVE_CLASS,
      active
    );

    document
      .querySelectorAll('[data-goal-team-discount]')
      .forEach((element) => {
        element.hidden = !active;

        element.setAttribute(
          'aria-hidden',
          active ? 'false' : 'true'
        );

        /*
         * 他のスクリプトによってdisplay:noneが
         * 残った場合にも表示できるようにします。
         */
        if (active) {
          element.style.removeProperty('display');
        }
      });

    /*
     * チーム専用クーポン利用時は、
     * Apple Pay等の追加決済ボタンを非表示にします。
     */
    document
      .querySelectorAll('[data-goal-additional-checkout]')
      .forEach((element) => {
        element.hidden = active;

        element.setAttribute(
          'aria-hidden',
          active ? 'true' : 'false'
        );
      });
  }

  /**
   * 表示更新を1フレームにまとめます。
   */
  function scheduleUpdate() {
    if (updateScheduled) {
      return;
    }

    updateScheduled = true;

    window.requestAnimationFrame(() => {
      updateScheduled = false;
      updateDisplay();
    });
  }

  /**
   * エラーを表示します。
   */
  function showError(container, message) {
    if (!container) {
      return;
    }

    const errorElement = container.querySelector(
      '[data-goal-discount-error]'
    );

    if (!errorElement) {
      return;
    }

    errorElement.textContent = message;
    errorElement.hidden = false;
  }

  /**
   * エラーを消します。
   */
  function clearError(container) {
    if (!container) {
      return;
    }

    const errorElement = container.querySelector(
      '[data-goal-discount-error]'
    );

    if (!errorElement) {
      return;
    }

    errorElement.textContent = '';
    errorElement.hidden = true;
  }

  /**
   * クーポン未入力時は通常のチェックアウトへ進みます。
   */
  function proceedWithoutDiscount(button) {
    const form = button.form;

    if (
      form &&
      typeof form.requestSubmit === 'function'
    ) {
      form.requestSubmit(button);
      return;
    }

    window.location.assign('/checkout');
  }

  /**
   * 購入手続きボタンの処理です。
   */
  function handleCheckout(event) {
    const clickedElement = event.target;

    if (!(clickedElement instanceof Element)) {
      return;
    }

    const button = clickedElement.closest(
      '[data-goal-checkout-button]'
    );

    if (!button) {
      return;
    }

    /*
     * TEAM GOALSTUDIO経由でない場合は、
     * Shopify標準の購入処理をそのまま実行します。
     */
    if (!isTeamDiscountActive()) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const inputId = button.getAttribute(
      'data-goal-discount-input-id'
    );

    const input = inputId
      ? document.getElementById(inputId)
      : null;

    const container = input
      ? input.closest('[data-goal-team-discount]')
      : null;

    const code = input
      ? input.value.trim()
      : '';

    clearError(container);

    /*
     * 入力欄が見つからない場合
     */
    if (!input) {
      showError(
        container,
        'クーポン入力欄を確認できませんでした。ページを再読み込みしてください。'
      );

      return;
    }

    /*
     * コード未入力の場合は通常決済へ進みます。
     */
    if (!code) {
      proceedWithoutDiscount(button);
      return;
    }

    if (code.length > 255) {
      showError(
        container,
        'クーポンコードが長すぎます。入力内容をご確認ください。'
      );

      input.focus();
      return;
    }

    /*
     * Shopifyの割引URLを経由して、
     * クーポン適用後にチェックアウトへ進みます。
     */
    const discountUrl =
      `/discount/${encodeURIComponent(code)}?redirect=/checkout`;

    window.location.assign(discountUrl);
  }

  /**
   * 入力開始時にエラーを消します。
   */
  function handleDiscountInput(event) {
    const input = event.target;

    if (!(input instanceof Element)) {
      return;
    }

    if (
      !input.matches('[data-goal-discount-input]')
    ) {
      return;
    }

    clearError(
      input.closest('[data-goal-team-discount]')
    );
  }

  /**
   * カートドロワーのAjax更新を監視します。
   */
  function observeDynamicElements() {
    if (!document.body || observer) {
      return;
    }

    observer = new MutationObserver((mutations) => {
      const hasRelevantChange = mutations.some(
        (mutation) =>
          mutation.type === 'childList' &&
          mutation.addedNodes.length > 0
      );

      if (hasRelevantChange) {
        scheduleUpdate();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  /**
   * 初期化処理です。
   */
  function initialize() {
    updateDisplay();

    document.addEventListener(
      'click',
      handleCheckout,
      true
    );

    document.addEventListener(
      'input',
      handleDiscountInput
    );

    observeDynamicElements();

    /*
     * team-access.jsより先に読み込まれた場合に備えて、
     * 読み込み後にも複数回再判定します。
     */
    window.setTimeout(updateDisplay, 100);
    window.setTimeout(updateDisplay, 500);
    window.setTimeout(updateDisplay, 1000);

    /*
     * 戻る・進む操作にも対応します。
     */
    window.addEventListener(
      'pageshow',
      updateDisplay
    );

    window.GoalTeamDiscount = {
      isActive: isTeamDiscountActive,
      refresh: updateDisplay
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize,
      { once: true }
    );
  } else {
    initialize();
  }
})();